import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';

import config from '../config';
import { useLazyQuery } from '../hooks/graph';
import Splash from '../components/splash';

function SignupCheckout({ history, location }) {
	const [ accountSignupPaymentSession ] = useLazyQuery(
		'accountSignupPaymentSession', {requestPolicy: 'network-only'});

	const searchParams = new URLSearchParams(location.search);
	const stripeEmail = searchParams.get('stripe_email'); // user email
	let stripePriceId = searchParams.get('stripe_price_id'); // product price
	stripePriceId = stripePriceId?.startsWith('price_') ? stripePriceId : null; // ex. 'price_1Nph6iKvFpRPi5W8wmRr5zvl'

	// reserved
	// const onCancelPayment = () => {
	// 	setPaymentCancelState(true);
	// };

	useEffect(() => {
		if (!stripePriceId) {
			history.replace('/signup/success?' + searchParams.toString());
			return;
		}

		const script = document.createElement('script');
		script.src = 'https://js.stripe.com/v3';
		script.async = false;

		script.onload = () => {
			accountSignupPaymentSession({
				stripePriceId,
				email: stripeEmail,
				successUrl: config.base + '/signup/success?' + searchParams.toString(),
				// reserved / cancelUrl: baseUrl: config.base + '...',
			}).then(({ data: { accountSignupPaymentSession: session } }) => {
				// eslint-disable-next-line new-cap
				const stripe = window.Stripe(config.services.stripe.publicKey);

				stripe.initEmbeddedCheckout(
					{clientSecret: session.clientSecret}

				).then(checkout => {
					checkout.mount('#checkout');

					// Juan, Jun23: "I understand it’s not a purchase,
					// but we do have the same structure in TS GA4"
					window.gtag?.('event', 'begin_checkout');

					// NB. be sure to set styling:
					// https://dashboard.stripe.com/settings/branding/checkout
					// - background: f8f9fa or something to make it look "transparent"
					// - ...

				}).catch(() => {
					history.replace('/'); // temporal
				});

			}).catch(() => {
				// example:
				// {
				//     "message": "Invalid product",
				//     "name": "ValidationError",
				//     "extensions": {}
				// }
				history.replace('/'); // temporal
			});
		};

		document.body.appendChild(script);

		return () => {
			document.body.removeChild(script);
		};
	}, [stripePriceId]);

	return (
		<div>
			<Splash>
				<Splash.Body>
					<h3 className="text-center mb-3">Sign up to SignalStack</h3>

					<p>
						Thanks for the registration.<br/>
						You will be redirected to the checkout page.
					</p>
				</Splash.Body>
			</Splash>

			<div id="checkout"></div>
		</div>
	);
}

export default withRouter(SignupCheckout);
